module.exports = __webpack_public_path__ + "img/sykf.4c9dc9b0.jpg";